import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { PROCESSING_RESULTS_SERVICE } from '../../services/processing-results/processing-results.service.base';
import { IProcessingResultsService } from '../../interfaces/services/processing-results-service.interface';
import { getErrorMessage } from '../../utils/error.utils';
import * as ProcessingResultsActions from './processing-results.actions';

@Injectable()
export class ProcessingResultsEffects {
  private actions$ = inject(Actions);
  private processingResultsService = inject<IProcessingResultsService>(PROCESSING_RESULTS_SERVICE);

  loadProcessingResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProcessingResultsActions.loadProcessingResults),
      switchMap(({ query }) => {
        const append = !!query.bookmark;
        return this.processingResultsService.getProcessingResults(query).pipe(
          map((page) =>
            ProcessingResultsActions.loadProcessingResultsSuccess({
              items: page.items,
              hasMoreData: page.continuation.hasMoreData,
              bookmark: page.continuation.bookmark ?? null,
              append,
            })
          ),
          catchError((error) =>
            of(
              ProcessingResultsActions.loadProcessingResultsFailure({
                error: getErrorMessage(error),
                append,
              })
            )
          )
        );
      })
    )
  );
}
